import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@store/utils';

export interface BusinessCategory {
  code: string;
  name: string;
  category: string;
}

export const typeOfBusinessCategoriesApi = createApi({
  reducerPath: 'typeOfBusinessCategories',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getBusinessType: builder.query<any, any>({
      query: () => ({
        url: `business_type/`,
      }),
    }),
  }),
});

export const { useGetBusinessTypeQuery } = typeOfBusinessCategoriesApi;